export const CARRIERS = 'carriers';
export const TIMELINE = 'timeline';
export const DETAILS = 'details';
export const WORKFLOWS = 'workflows';
export const MY_BIDS = 'myBids';
export const MESSAGES = 'messages';
export const STAGES = 'stages';
export const CARRIER_BIDS = 'carrierBids';
